import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardHotelPWA/components/l10n";
import { UitkCheckbox } from "uitk-react-switch";
import { HotelWizardStateProps } from "components/flexComponents/WizardHotelPWAv2/typings";
import { useLocalization } from "@shared-ui/localization-context";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { UitkText } from "uitk-react-text";
const CheckboxTracked = FlexClickTracker(UitkCheckbox);

export interface HotelAddFlightCheckboxProps extends HotelWizardStateProps {
  packageRatesTermsUrl?: string;
  percentSave?: number;
  isChecked?: boolean;
}

export const HotelPackageRatesTermsCheckbox = observer(
  ({ hotelWizardState, packageRatesTermsUrl, percentSave, isChecked }: HotelAddFlightCheckboxProps) => {
    const { formatText } = useLocalization();
    const urlParameterName = "packageRates";

    const handleChange = () => {
      hotelWizardState.togglePackageRatesTermsCheckbox();
    };

    return (
      <div>
        <UitkText size={300} weight="bold" spacing="six">
          {formatText(locKeys.hotelPackageRatesTermsCheckboxHeader, percentSave)}
        </UitkText>
        <CheckboxTracked
          id={urlParameterName}
          data-testid={urlParameterName}
          checked={!!isChecked}
          onChange={handleChange}
          moduleName="WizardHotelPWAv2"
          rfrr="TermsConditions_PackageRates"
          value={!!isChecked && "true"}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: formatText(locKeys.hotelPackageRatesTermsCheckboxLabel, packageRatesTermsUrl),
            }}
          />
        </CheckboxTracked>
      </div>
    );
  }
);
